

exports.__esModule = true;
exports.createShippingChangeFeature = exports.hasOnShippingChangeCallback = undefined;

var _squid = require('squid');

var _factory = require('xo-shipping-change/src/factory');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var hasOnShippingChangeCallback = exports.hasOnShippingChangeCallback = function hasOnShippingChangeCallback() {
    return window.xprops && window.xprops.onShippingChange;
};

var createShippingChangeFeature = exports.createShippingChangeFeature = function createShippingChangeFeature() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        orderID = _ref.orderID,
        checkoutCart = _ref.checkoutCart,
        checkoutSession = _ref.checkoutSession,
        checkoutAppData = _ref.checkoutAppData,
        _ref$callbackFn = _ref.callbackFn,
        callbackFn = _ref$callbackFn === undefined ? _squid.$util.noop : _ref$callbackFn;

    var feature = {
        enums: {
            LOADING: 'loading',
            REJECTED: 'rejected',
            UPDATED: 'updated',
            FAILED: 'failed'
        },
        status: null,
        shippingChangeFactory: (0, _factory.$ShippingChangeFactory)({ orderID: orderID, checkoutAppData: checkoutAppData, checkoutCart: checkoutCart }),
        callOnShippingChange: _squid.$util.noop
    };

    feature.callOnShippingChange = function () {
        var doneFn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _squid.$util.noop;

        if (!hasOnShippingChangeCallback()) {
            return doneFn();
        }

        var successFn = function successFn() {
            var updatedMsg = (0, _squid.$renderContent)('shippingCallback.updated', {
                amount: checkoutCart.get('purchase.amounts.total.amount_formatted_currency')
            });

            feature.status = feature.enums.UPDATED;
            checkoutSession.message = {
                msgs: [updatedMsg],
                type: 'info'
            };
        };

        var rejectFn = function rejectFn() {
            var rejectedMsg = (0, _squid.$renderContent)('shippingMethod.shippingRegionUnsupported', {
                merchant: checkoutAppData.getMerchantDisplayName()
            });

            feature.status = feature.enums.REJECTED;
            checkoutSession.message = {
                msgs: [rejectedMsg],
                type: 'warning'
            };
        };

        var loadingMsg = _squid.$locale.content.get('shippingCallback.loading');

        _squid.$event.emit('loading');
        _squid.$event.emit('loadingMessage', loadingMsg);

        return feature.shippingChangeFactory.getPayload(checkoutSession.get('shipping')).then(function (payload) {
            _logger.$logger.info('shipping_change_payload_recieved', payload);

            return feature.shippingChangeFactory.callOnShippingChange(payload);
        }).then(function (_ref2) {
            var cartHasChanged = _ref2.cartHasChanged,
                rejected = _ref2.rejected;


            _logger.$logger.info('shipping_change_called', { cartHasChanged: cartHasChanged, rejected: rejected });

            callbackFn();

            if (rejected) {
                return rejectFn();
            } else if (cartHasChanged) {
                return successFn();
            } else {
                // If the callback was not rejected, and the cart
                // was not changed we can remove any statuses
                // that prevent finishing checkout.
                feature.status = null;
            }
        }).then(doneFn)['catch'](function (err) {
            _logger.$logger.error('shipping_change_error', err);

            feature.status = feature.enums.FAILED;
            _uiRouter.$state.go('checkout.genericError');
        })['finally'](function () {
            _squid.$event.emit('loaded');
        });
    };

    return feature;
};

_squid.$renderContent;

_squid.$util;

_squid.$locale;

_squid.$event;

_factory.$ShippingChangeFactory;

_uiRouter.$state;

_logger.$logger;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-review/lib/shippingChangeFeature.js
// module id = ./pages/xo-review/lib/shippingChangeFeature.js
// module chunks = 0